import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: 'How does the audio guestbook work?',
    answer: 'You create an Ihsanly guestbook and get a unique QR code. Display it at your wedding, and guests scan it with their phone to record a voice message. No app download needed — it works right in their browser.'
  }, {
    question: 'Do my guests need to download an app?',
    answer: "Nope! Everything works in the mobile browser. Guests just scan, tap record, and speak. It's that simple."
  }, {
    question: 'How much does it cost?',
    answer: 'Ihsanly starts at just $29 — a fraction of what phone rentals charge. No hidden fees, no damage deposits, no shipping costs.'
  }, {
    question: 'Can I download the voicemails?',
    answer: "Yes! You can download individual messages or all of them at once from your dashboard. They're saved as high-quality audio files."
  }, {
    question: 'Is there a limit on how many messages guests can leave?',
    answer: "No limits at all. Whether you get 10 messages or 200, they're all included."
  }, {
    question: "What if a guest isn't tech-savvy?",
    answer: "The recording flow is designed to be incredibly simple. Scan, tap, talk, done. We've had guests of all ages use it without any issues."
  }];
  return <section className="py-24 bg-brown-800 text-white" data-id="element-137">
      <div className="max-w-3xl mx-auto px-4" data-id="element-138">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-139">
          <h2 className="text-4xl md:text-5xl font-serif italic mb-4" data-id="element-140">
            Common Questions
          </h2>
        </motion.div>

        <div className="space-y-2" data-id="element-141">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="border-b border-brown-700" data-id="element-142">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full py-6 flex items-center justify-between text-left focus:outline-none group" data-id="element-143">
                <span className="text-lg font-bold group-hover:text-accent-pink transition-colors" data-id="element-144">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-cream-400 transition-transform duration-300 ${openIndex === index ? 'transform rotate-180' : ''}`} data-id="element-145" />
              </button>
              <AnimatePresence data-id="element-146">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-147">
                    <p className="pb-6 text-cream-400 leading-relaxed" data-id="element-148">
                      {faq.answer}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}